import {createSelector} from 'reselect';

import {getFontSize} from './setupSelector';
import {getTimezoneState} from './timeZoneSelector';

const getDeviceInfoStore = (state) => state.deviceInfoStore;

export const getDeviceProperties = createSelector(
  [getDeviceInfoStore],
  (deviceInfoStore) => deviceInfoStore.deviceProperties,
);

export const getLicenseType = createSelector([getDeviceInfoStore], (deviceInfoStore) => deviceInfoStore.licenseType);

export const isChangedDeviceSetting = createSelector(
  [getDeviceProperties, getTimezoneState],
  (deviceProperties, timezoneState) => {
    const {deviceName, originDeviceName} = deviceProperties;
    const {
      isAutoSync,
      isAutoSyncOrigin,
      geoArea,
      geoAreaOrigin,
      region,
      regionOrigin,
      date,
      dateOrigin,
      time,
      timeOrigin,
    } = timezoneState;

    if (
      originDeviceName === undefined ||
      isAutoSyncOrigin === undefined ||
      geoAreaOrigin === undefined ||
      regionOrigin === undefined ||
      dateOrigin === undefined ||
      timeOrigin === undefined
    )
      return false;

    if (isAutoSyncOrigin) {
      return (
        deviceName !== originDeviceName ||
        isAutoSync !== isAutoSyncOrigin ||
        geoArea !== geoAreaOrigin ||
        region !== regionOrigin
      );
    }

    return (
      deviceName !== originDeviceName ||
      isAutoSync !== isAutoSyncOrigin ||
      geoArea !== geoAreaOrigin ||
      region !== regionOrigin ||
      date !== dateOrigin ||
      time !== timeOrigin
    );
  },
);

export const getDeviceSetting = createSelector(
  [getDeviceProperties, getFontSize, isChangedDeviceSetting],
  (deviceProperties, fontSize, isChanged) => {
    const {organization, deviceName} = deviceProperties;

    return {
      organization,
      deviceName,
      fontSize,
      isChanged,
    };
  },
);
